import { useEffect, useState } from "react";
import CustomButton from "../../../components/CustomButton";
import SubHeadings from "../../../components/SubHeadings";
import { plus } from "../../../asset";
import DataTable, { Column } from "../../../components/DataTable";
import { Student } from "../../../types/studentType";
import { useEditMode } from "../../../context/EditModeContext";
import { useNavigate } from "react-router-dom";
import { popupNavigation } from "../../../util/functions/UniversalFunctions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { Attender } from "../../../types/attenderType";
import { fetchAttenders } from "../../../features/attender-controller/attenderSlice";
import attenderApis from "../../../api/attenderControllerApis";
import useConfirmToast from "../../../util/hooks/useConfirmToast";

export default function EscortDetalis({ studentId }: { studentId?: number }) {
  const [searchFilters, setSearchFilters] = useState({});
  const { isEditing } = useEditMode();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { confirm, modal } = useConfirmToast();

  const { list: attenders, loading } = useSelector(
    (state: RootState) => state.attender,
  );

  useEffect(() => {
    if (studentId) {
      dispatch(fetchAttenders(studentId));
    }
  }, [studentId, dispatch]);

  const columns: Column<Attender>[] = [
    {
      label: "SL NO.",
      accessor: "attenderId",
      searchable: false,
    },
    {
      label: "Escort Name",
      accessor: "studentName",
      render: (item) => (
        <div className="font-bold text-sm text-neutral-400">
          {item?.fullName}
        </div>
      ),
    },
    {
      label: "Relationship with Child",
      accessor: "relation",
    },
    {
      label: "Mobile Number",
      accessor: "mobileNo",
    },
    {
      label: "Action",
      accessor: "action",
      searchable: false,
      render: (item) => (
        <div className="flex gap-4">
          <button
            onClick={() =>
              navigate(popupNavigation("addEscort"), {
                state: {
                  studentId,
                  editData: item,
                },
              })
            }
            disabled={!isEditing}
            className="px-2 py-1 text-nowrap text-xs text-warning-700 bg-warning-50 rounded-[4px] font-medium"
          >
            Edit
          </button>
          <button
            onClick={() =>
              navigate(`/escort-id-card`, {
                state: { attender: item },
              })
            }
            className="px-2 py-1 text-nowrap text-xs text-primary-700 bg-primary-50 rounded-[4px] font-medium"
          >
            ID Card
          </button>
          <button
            disabled={!isEditing}
            onClick={async () => {
              if (!item?.attenderId) return;

              const response = await confirm(
                "Are you sure you want to remove this attender?",
              );

              if (!response) return;

              try {
                await attenderApis.deleteAttender(item.attenderId);

                if (studentId) {
                  dispatch(fetchAttenders(studentId));
                }
              } catch (err) {
                console.error(err);
              }
            }}
            className="px-2 py-1 text-nowrap text-xs text-error-700 bg-error-50 rounded-[4px] font-medium"
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  const handleSearchChange = (accessor: string, value: string) => {
    setSearchFilters((prev) => ({ ...prev, [accessor]: value }));
  };

  const handleSearchSubmit = (filters: Record<string, string>) => {
    console.log("Search filters:", filters);
    setSearchFilters(filters);
  };

  return (
    <div className="px-4 md:px-9 flex flex-col md:flex-row gap-9 min-w-0">
      <div className="flex flex-col gap-7 w-full py-7">
        <div className="flex flex-col md:flex-row gap-4 md:justify-between md:items-center">
          <SubHeadings text="Escort’s Details" />
          <div className="flex justify-end items-end">
            <CustomButton
              text="Add Attendar"
              color="bg-success-600"
              icon={plus}
              disabled={!isEditing}
              onClick={() =>
                navigate(popupNavigation("addEscort"), {
                  state: { studentId },
                })
              }
            />
          </div>
        </div>
        <div>
          <DataTable
            columns={columns}
            data={attenders}
            searchFilters={searchFilters}
            onSearchChange={handleSearchChange}
            onSearchSubmit={handleSearchSubmit}
            isLoading={loading}
          />
        </div>
      </div>
      {modal}
    </div>
  );
}
